import { useRef } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';

import ProductBtn from './components/productBtn';
import ProductImage from './components/productImage';
import ProductParams from './components/productParams';
import ProductPDF from './components/productPDF';
import ProductPDFDesc from './components/productPDFDesc';
import ProductTabs from './components/productTabs';
import ProductTop from './components/productTop';

import CopyText from '@/components/copyText';

export default function ItemDetailPage({ data, productRecommendMounted, productPdfDesc }) {
  const topPlaceholderRef = useRef(null);
  const bottomPlaceholderRef = useRef(null);

  const productRecord = data?.productRecord || {};
  const isOversea = data?.isOversea;

  return (
    <div>
      <section className="flex rounded-[20px] bg-[#fff] p-[30px] pt-[30px] w-[810px]" data-spm="pd">
        <ProductImage data={data} />
        <div className="w-[460px] ml-[30px]">
          {!data?.isMro ? (
            <div className="flex items-center">
              <CopyText
                tagName="h1"
                className="lc-text-hidden text-[20px] text-[#0B1832] h-[26px] font-bold cursor-pointer"
                title={productRecord?.productModel || productRecord?.productCodeManufacturer}
                innerText={productRecord?.productModel || productRecord?.productCodeManufacturer}
                isHover={false}
              />
              {data?.rohsLabal && <SvgIcon app="item" iconName="rohs" className="ml-[5px] w-[32px] h-[27px]" />}
            </div>
          ) : (
            <div className="flex items-center">
              <CopyText
                tagName="h1"
                className="text-[20px] max-w-[90%] text-[#0B1832] font-bold inline-block leading-[26px] cursor-pointer"
                title={productRecord?.productName}
                innerText={productRecord?.productName}
                isHover={false}
              />
              {data?.rohsLabal && <SvgIcon app="item" iconName="rohs" className="ml-[5px] w-[32px] h-[27px]" />}
            </div>
          )}
          <div className="border-half mt-[8px] w-[460px]"></div>
          <ProductTop data={data} />
          <ProductBtn data={data} />
        </div>
      </section>
      {/* 占位元素，用于检测是否应该置顶 */}
      <div ref={topPlaceholderRef} className="h-0" />
      {!isOversea && (
        <ProductTabs
          items={[
            { id: 'productParamsTabItem', name: '商品参数' },
            { id: 'dataSheetTabItem', name: '数据手册PDF' },
            { id: 'productRecommendTabItem', name: '买了又买' },
          ]}
          productRecommendMounted={productRecommendMounted}
          topPlaceholderRef={topPlaceholderRef}
          bottomPlaceholderRef={bottomPlaceholderRef}
        />
      )}
      <ProductParams data={data} productPdfDescData={productPdfDesc} />
      <ProductPDFDesc productPdfDescData={productPdfDesc} />
      <ProductPDF data={data} />
      {/* 占位元素，用于检测是否应该调整宽度 */}
      <div ref={bottomPlaceholderRef} className="h-0" />
    </div>
  );
}
